import { Fetch, Params } from '../../shared/types';
import type { ActionType, Zap } from '../types';

type RequestData = {
  action: string;
  authentication_id?: number;
  page?: number;
  params?: Params;
  selected_api: string;
  type_of: ActionType;
  test_poll?: boolean;
  is_sampling?: boolean;
  zap_id?: Zap['id'];
};

type ResponseData<Result> =
  | {
      status: 'success';
      results: Result[];
      errors: undefined;
    }
  | {
      status: 'error';
      results: null;
      errors: string[];
    };

export const invoke = <Result>(fetch: Fetch, body: RequestData) =>
  fetch<ResponseData<Result>>('/api/v4/implementations/invoke-sync/', {
    body,
  });

export default invoke;
